
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const testimonials = [
    {
      name: "M.K",
      location: "大阪府",
      course: "入門講座/スキンケア",
      text: "西洋のアロマと日本の和精油、同じようでちょっと違う感じがしました。食べ物や文化と同じで、日本人には日本で作られたものが体質的に合っているのはアロマも同じ。なんかわかる気がするけど、西洋のイメージなので日本で作られてる和精油があるって知れてよかったです!最初に匂いを嗅いだときのイメージを大事に。って言ってくれたのが印象的で、人によって感じ方が違うからこそ、その人が感じたイメージを大切に。それぞれに合った香りを見つけることも大事なんだろうな。と学びました!made in Japanを大切にしたいと思います♡"
    },
    {
      name: "T.S",
      location: "東京都",
      course: "入門講座/スキンケア",
      text: "アロマが作られる森林の現状とアロマの歴史が初めて知ることばかりで、わかりやすかったです！アロマがまた深くなりました！木がもともと好きなので、大切にしたいと思いました！"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "サロンには温かい照明と観葉植物があり、窓からは自然の光が入ってきて、都会を忘れるようでとてもリラックスできました。"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "アロマトリートメントは初めてでしたが、安心して受けられました。いい香りとリラックスできる音楽がかかっていて、心地よかったです。水の音が特にリラックスできました。"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "提案された精油から好みの香りを選び、オーダーメイドのブレンド精油を作って頂けるのがとても嬉しかったです。"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "首肩の凝りと頭痛に悩まされていましたが、身体全体が軽くなり痛みがとれてスッキリしました！アロマの香りにも癒されて気持ちよかったです。"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "施術前の話もゆっくり聞いて下さり、施術中も穏やかでとてもリラックスして受けられました。"
    },
    {
      name: "",
      location: "",
      course: "アロマトリートメント",
      text: "どこまでもお客様目線の贅沢サロンで、症状を解消するアプローチを一緒に考えてくれます。 事前に丁寧なカウンセリングをして頂けることで、健康になるプラスのイメージを持ったまま施術が受けられました！"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-green-50"
      >
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">お客様の声</h1>
        </div>
      </section>

      {/* お客様の声セクション */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 border border-gray-100">
                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-semibold text-gray-900">
                      {testimonial.name && (index === 2 ? testimonial.name : `${testimonial.name}さん`)}
                    </h3>
                    <span className="text-sm text-gray-500">{testimonial.location}</span>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                    {testimonial.course}
                  </span>
                </div>
                <p className="text-gray-700 leading-relaxed">{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-green-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            あなたも森の香りを体験してみませんか？
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            和精油で、心と身体を癒すアロマセラピーを始めましょう
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/courses" 
              className="bg-white text-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              講座を見る
            </Link>
            <Link 
              to="/contact" 
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Testimonials;
